import { useTranslation } from "@msuite/ui/localization";
import { getAttendanceTypeTranslationKey } from "@msuite/utils/attendances";
import type { AttendanceListItem } from "@msuite/utils/types";
import React from "react";

/** Props Interface */
interface UserCalendarAttendanceItemProps {
	item: AttendanceListItem;
}

export function UserCalendarAttendanceItem({ item }: UserCalendarAttendanceItemProps) {
	const { t } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<p>{t(getAttendanceTypeTranslationKey(item))}</p>
		</React.Fragment>
	);
}
